import './feedback.scss';

export default () => {
};
